import { Button } from "@albelli/arc-3-react/lib/Button/Button";
import { ButtonGroup } from "@albelli/arc-3-react/lib/ButtonGroup/ButtonGroup";
import { Grid } from "@albelli/arc-3-react/lib/Grid";
import { Panel } from "@albelli/arc-3-react/lib/Panel/Panel";
import accountDeleted1 from "assets/account-deleted-1.png";
import accountDeleted2 from "assets/account-deleted-2.png";
import { ErrorBoundary } from "components/common/ErrorBoundary/ErrorBoundary";
import { Footer } from "components/common/Footer/Footer";
import { Header } from "components/common/Menu/Menu";
import { useLocalisedDocumentTitle } from "components/_hooks/useLocalisedDocumentTitle";
import { useHistory } from "components/_hooks/useRouter";
import React, { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { routes } from "../../../routes";
import styles from "./AccountDeleted.module.css";

export const AccountDeleted = () => {
  useLocalisedDocumentTitle();
  const history = useHistory();
  const menu = useSelector(state => state.menu);
  const goHome = useCallback(() => {
    history.push(routes.home);
  }, [history]);

  return (
    <ErrorBoundary>
      <Header />
      <div className="arc3-container" data-cy="AccountDeletedPage">
        <div className="arc3-padding--left-lg arc3-padding--right-lg">
          <h1>
            <FormattedMessage id="accountDeleted.title" defaultMessage="Your account has been successfully deleted" />
          </h1>
          <p>
            <FormattedMessage id="accountDeleted.message1" defaultMessage="We’re sad to see you go." />
            <br />
            <FormattedMessage
              id="accountDeleted.message2"
              defaultMessage="We have deleted all your personal data, photos, projects, and order history."
            />
          </p>
        </div>

        <Grid container noSpacing className={styles.gridContainer}>
          <Grid cell column={6} className={styles.gridItem1}>
            <Panel className={styles.panel}>
              <div className={styles.panelContent}>
                <img src={accountDeleted1} className={"arc3-hide-for-small  " + styles.image} alt="" />
                <div className={styles.panelTextContainer}>
                  <h3 className="arc3-no-margin">
                    <FormattedMessage id="accountDeleted.createAccount.title" defaultMessage="Changed your mind?" />
                  </h3>
                  <p>
                    <FormattedMessage
                      id="accountDeleted.createAccount.message"
                      defaultMessage="Create a new account at bonusprint and start fresh!"
                    />
                  </p>
                  <ButtonGroup>
                    <Button onClick={goHome} data-cy="AccountDeletedCreateAccountButton">
                      <FormattedMessage id="accountDeleted.createAccount.button" defaultMessage="Create an account" />
                    </Button>
                  </ButtonGroup>
                </div>
              </div>
            </Panel>
          </Grid>
          <Grid cell column={6}>
            <Panel className={styles.panel}>
              <div className={styles.panelContent}>
                <img src={accountDeleted2} className={"arc3-hide-for-small  " + styles.image} alt="" />
                <div className={styles.panelTextContainer}>
                  <h3 className="arc3-no-margin">
                    <FormattedMessage id="accountDeleted.viewProducts.title" defaultMessage="Explore our products" />
                  </h3>
                  <p>
                    <FormattedMessage
                      id="accountDeleted.viewProducts.message"
                      defaultMessage="We’re sad to see you go. Maybe you would like to stick around a bit longer, explore our photo
                    products and get creative."
                    />
                  </p>
                  <ButtonGroup>
                    <Button secondary href={menu.items.routes.AllProducts} data-cy="AccountDeletedExploreButton">
                      <FormattedMessage id="accountDeleted.viewProducts.button" defaultMessage="View products" />
                    </Button>
                  </ButtonGroup>
                </div>
              </div>
            </Panel>
          </Grid>
        </Grid>
      </div>
      <Footer />
    </ErrorBoundary>
  );
};
